import { questionConstants } from '../../constants';
import { questionService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionConstants.GETALL_REQUEST });
    const success = (questions: any) => ({ type: questionConstants.GETALL_SUCCESS, payload: questions });
    const failure = (error: any) => ({ type: questionConstants.GETALL_FAILURE, payload: error });

    try {
      const questions = await questionService.getAll();
      dispatch(success(questions));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getAllPaginated = (params: { page: number; limit: number; search?: string; question_type_id?: string; question_topic_id?: string; difficulty?: string; grade_ids?: string }) => {
  return async (dispatch: any) => {
    const request = () => ({ type: questionConstants.GETALL_REQUEST });
    const success = (data: any) => ({ type: questionConstants.GETALL_SUCCESS, payload: data });
    const failure = (error: any) => ({ type: questionConstants.GETALL_FAILURE, payload: error });

    dispatch(request());

    try {
      const data = await questionService.getAllPaginated(params);
      dispatch(success(data));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const createQuestion = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const question = await questionService.create(formData);
      dispatch(success(question));
      dispatch(notificationActions.addNotification('Tạo câu hỏi thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(question: any) {
    return { type: questionConstants.CREATE_REQUEST, payload: question };
  }
  function success(question: any) {
    return { type: questionConstants.CREATE_SUCCESS, payload: question };
  }
  function failure(error: any) {
    return { type: questionConstants.CREATE_FAILURE, error };
  }
};

const deleteQuestion = (questionId: any) => {
  return async (dispatch: any) => {
    dispatch(request(questionId));

    try {
      await questionService.remove(questionId);
      dispatch(success(questionId));
      dispatch(notificationActions.addNotification('Xóa câu hỏi thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(questionId: number) {
    return { type: questionConstants.DELETE_REQUEST, payload: questionId };
  }
  function success(questionId: number) {
    return { type: questionConstants.DELETE_SUCCESS, payload: questionId };
  }
  function failure(error: any) {
    return { type: questionConstants.DELETE_FAILURE, error };
  }
};

const deleteMultipleQuestions = (questionIds: number[]) => {
  return async (dispatch: any) => {
    dispatch(request(questionIds));

    try {
      await questionService.removeMultiple(questionIds);
      dispatch(success(questionIds));
      dispatch(notificationActions.addNotification(`Đã xóa ${questionIds.length} câu hỏi thành công!`, 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(questionIds: number[]) {
    return { type: questionConstants.DELETE_MULTIPLE_REQUEST, payload: questionIds };
  }
  function success(questionIds: number[]) {
    return { type: questionConstants.DELETE_MULTIPLE_SUCCESS, payload: questionIds };
  }
  function failure(error: any) {
    return { type: questionConstants.DELETE_MULTIPLE_FAILURE, error };
  }
};

const updateQuestion = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const updatedQuestion = await questionService.update(formData);
      dispatch(success(updatedQuestion));
      dispatch(notificationActions.addNotification('Cập nhật câu hỏi thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(question: any) {
    return { type: questionConstants.UPDATE_REQUEST, payload: question };
  }
  function success(question: any) {
    return { type: questionConstants.UPDATE_SUCCESS, payload: question };
  }
  function failure(error: any) {
    return { type: questionConstants.UPDATE_FAILURE, error };
  }
};

export const questionActions = {
  getAll,
  getAllPaginated,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  deleteMultipleQuestions
};
